export function isRTL(text: string): boolean {
  // RTL Unicode ranges
  const rtlChars = /[\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/

  // Remove code blocks and HTML tags from the text before checking direction
  const textWithoutCode = text
    .replace(/```[\s\S]*?```/g, '')
    .replace(/`[^`]*`/g, '')
    .replace(/<[^>]*>/g, '')

  // Count RTL characters in the first few words
  const firstFewChars = textWithoutCode.trim().slice(0, 100)
  const rtlCount = (firstFewChars.match(rtlChars) || []).length

  return rtlCount > 0
}

export function processTextDirection(text: string): string {
  if (text.startsWith('```') || text.startsWith('`')) {
    return text
  }

  const rtlChars = /[\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/
  const variablePattern = /\[([^\]]+)\]/g // Pattern to match [variables]
  const markdownPattern = /^(\s*(?:[#*_-]|\d+\.|\[|\*{1,2}|_{1,2})*\s*)(.*?)(\s*(?:[#*_-]|\[|\*{1,2}|_{1,2})*\s*)$/

  return text
    .split('\n')
    .map(line => {
      if (!line.trim()) return line

      // Preserve markdown formatting at start/end of lines
      const markdownMatch = line.match(markdownPattern)
      if (markdownMatch) {
        const [, prefix, content, suffix] = markdownMatch

        // Only process content if it contains RTL characters
        if (rtlChars.test(content)) {
          const processedContent = content.replace(
            variablePattern,
            match => `\u202D${match}\u202C`, // Using LRO and PDF markers
          )
          return `${prefix}\u202E${processedContent.trim()}\u202C${suffix}`
        }
      }

      // For lines with RTL characters
      if (rtlChars.test(line)) {
        const processedLine = line.replace(
          variablePattern,
          match => `\u202D${match}\u202C`, // Using LRO and PDF markers
        )
        return `\u202E${processedLine.trim()}\u202C`
      }

      return line
    })
    .join('\n')
}
